import type {ImportDuplicateCheckResponseDto as ImportDuplicateCheckResult} from '../../types'
import type {CreateRiaRequest as ImportPreviewRow} from '../../types'
import type {ParseError} from '../../helpers/excelParser'

import {ImportPreviewTable} from './ImportPreviewTable'
import {ImportValidationAlert} from './ImportValidationAlert'

type PreviewStepProps = {
  duplicateRiNumbers: string[]
  duplicateImportCheck?: ImportDuplicateCheckResult | null
  parsedRows: ImportPreviewRow[]
  parseErrors: ParseError[]
  excludedRows: Set<number>
  onToggleRow: (index: number) => void
}

export const PreviewStep = ({
  duplicateRiNumbers,
  duplicateImportCheck,
  parsedRows,
  parseErrors,
  excludedRows,
  onToggleRow
}: PreviewStepProps) => {
  return (
    <div>
      <ImportValidationAlert
        duplicateRiNumbers={duplicateRiNumbers}
        unrecognizedColumns={[]}
        duplicateImportCheck={duplicateImportCheck}
      />
      <ImportPreviewTable
        rows={parsedRows}
        errors={parseErrors}
        excludedRows={excludedRows}
        onToggleRow={onToggleRow}
      />
    </div>
  )
}
